const NO_LOOM_AUTH_PROBE = new Set([
  '/writers',
  '/appeal',
  '/trust',
  '/faq',
  '/how-we-help',
  '/how-we-help-writers',
  '/diversity-sustainability',
  '/diversity-and-sustainability',
  '/dei',
  '/editor',
  '/verify-recovery-email',
  '/verify-login-email',
]);

export const skipsLoomAuthProbe = (pathname = '') => (
  NO_LOOM_AUTH_PROBE.has(pathname)
  || pathname === '/admin'
  || pathname.startsWith('/admin/')
);

export const usesOptionalLoomAuthProbe = (pathname = '') => (
  pathname === '/'
  || pathname === '/login'
  || pathname === '/codex'
  || pathname === '/marketplace'
  || pathname === '/templates/marketplace'
  || pathname === '/my-library'
  || pathname.startsWith('/bookstore')
  || pathname.startsWith('/authors/')
  || pathname.startsWith('/book/')
  || pathname.startsWith('/read-free/')
  || pathname.startsWith('/stacks/')
);

export const needsBookstoreAuthProbe = (pathname = '') => (
  pathname === '/bookstore'
  || pathname.startsWith('/bookstore/')
  || pathname === '/my-library'
  || pathname.startsWith('/read-free/')
  || pathname.startsWith('/book/')
);